import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
import ComponentVariable from "../../item/ComponentVariable.vue";
import { computed, toRef } from "vue";
import { organizeComponentVariables } from "..";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
import { useComponentVariableSearchables } from "src/shared/store/component-variable-searchable/composables/useComponentVariableSearchables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableListStandard',
    props: {
        componentMutableKey: {},
        hiddenVariableNames: {},
        isMasked: { type: Boolean },
        componentDrawerRouteConfig: {}
    },
    setup(__props) {
        const props = __props;
        const { componentMutable } = useComponentMutable(toRef(props, "componentMutableKey"));
        const componentId = computed(() => {
            var _a;
            return (_a = componentMutable.value) === null || _a === void 0 ? void 0 : _a.component_id;
        });
        const { componentVariableSearchables } = useComponentVariableSearchables(componentId);
        const variablesWithoutHidden = computed(() => {
            return componentVariableSearchables.value.filter((variable) => { var _a; return !((_a = props.hiddenVariableNames) === null || _a === void 0 ? void 0 : _a.includes(variable.name)); });
        });
        const organizedComponentVariables = computed(() => {
            return organizeComponentVariables(variablesWithoutHidden.value);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["component-variable-list-v2", { 'component-variable-list--masked': _ctx.isMasked }])
            }, [
                (organizedComponentVariables.value.basic.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(organizedComponentVariables.value.basic, (variable) => {
                        return (_openBlock(), _createBlock(ComponentVariable, {
                            key: variable.name,
                            "component-id": variable.componentId,
                            "variable-name": variable.name,
                            "component-mutable-key": _ctx.componentMutableKey,
                            componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                        }, null, 8 /* PROPS */, ["component-id", "variable-name", "component-mutable-key", "componentDrawerRouteConfig"]));
                    }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                (organizedComponentVariables.value.advanced.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(organizedComponentVariables.value.advanced, (variable) => {
                        return (_openBlock(), _createBlock(ComponentVariable, {
                            key: variable.name,
                            "component-id": variable.componentId,
                            "variable-name": variable.name,
                            "component-mutable-key": _ctx.componentMutableKey,
                            componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                        }, null, 8 /* PROPS */, ["component-id", "variable-name", "component-mutable-key", "componentDrawerRouteConfig"]));
                    }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
